import {Button, Box, Typography} from '@mui/material'
import React from 'react'
import {useSelector} from 'react-redux'

import {JobSiteSelectionModal} from '../../../OrderIntake/RMC/components/JobSiteSelectionModal'
import {useJobSiteSelectionModal} from '../../../OrderIntake/RMC/hooks/useJobSiteSelectionModal'
import {selectSelectedCustomerFilter} from '../../../Organisms/Customers/Customers.selector'
import {AppState} from '../../../Root.store'

export const ScheduleNewRMCDelivery = () => {
  const selectedCustomer = useSelector((state: AppState) => selectSelectedCustomerFilter(state))
  const customerId = selectedCustomer?.customerId || ''

  const {
    isOpen,
    openModal,
    closeModal,
    handleJobSiteSelect,
    handleCreateNewOrder,
    handleContactSales
  } = useJobSiteSelectionModal()

  const handleNewRMCDelivery = () => {
    console.log('Opening RMC job site selection modal...')
    openModal()
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          padding: 2
        }}
      >
        <Typography variant="body2" color="textSecondary">
          Schedule a new ready mixed concrete delivery for your job site.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleNewRMCDelivery}
          data-test-id="button-new-rmc-delivery"
          fullWidth
          sx={{
            textTransform: 'none',
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: 500
          }}
        >
          New RMC delivery
        </Button>
      </Box>

      <JobSiteSelectionModal
        open={isOpen}
        customerId={customerId}
        onClose={closeModal}
        onSelectSite={handleJobSiteSelect}
        onCreateNewOrder={handleCreateNewOrder}
        onContactSales={handleContactSales}
      />
    </>
  )
}
